// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print Styles for Bilingual Assignment Forms and History Displays */
/* A4 Paper: 210mm x 297mm (8.27" x 11.69") */

@media print {

  /* Reset and prepare for print */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Reset margins and ensure proper A4 sizing */
  @page {
    size: A4 landscape;
    margin: 8mm 10mm 8mm 10mm;
  }

  /* ===================================================================
     UNIVERSAL HIDING RULES - Hide navigation and chrome
     =================================================================== */
  .no-print,
  .print-hidden,
  [data-print="hidden"],
  nav,
  .sidebar,
  .navigation,
  .menu,
  .drawer,
  .header-buttons,
  .back-button,
  .floating-button,
  .fab,
  .modal-backdrop,
  .app-header,
  .app-navigation,
  [role="navigation"],
  [data-testid*="navigation"],
  [data-testid*="sidebar"],
  [data-testid*="menu"],
  .screen-header,
  .top-bar,
  .status-bar,
  .tab-bar,
  .bottom-navigation,
  .main-navigation,
  .navigation-drawer,
  .app-drawer,
  .react-navigation-stack,
  .rn-screen,
  [class*="navigation"],
  [class*="sidebar"],
  [class*="header"],
  [class*="menu"],
  [class*="drawer"],
  [id*="navigation"],
  [id*="sidebar"],
  [id*="header"],
  [id*="menu"],
  /* React Native Web specific */
  [style*="width: 280px"],
  [style*="border-right"] {
    display: none !important;
    visibility: hidden !important;
    position: absolute !important;
    left: -9999px !important;
  }

  /* Hide all body children except the app root or print container */
  body.printing-mode>div:not(#root):not(.bilingual-form-container):not([class*="form"]) {
    display: none !important;
  }

  /* Ensure the form container uses normal flow for scaling */
  .bilingual-form-container,
  [class*="assignment-form"],
  [class*="bilingual-form"],
  #bilingual-form-container {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    z-index: 9999 !important;
    overflow: visible !important;
  }

  body.printing-mode .bilingual-form-container,
  body.printing-mode [class*="assignment-form"],
  body.printing-mode [class*="bilingual-form"],
  body.printing-mode #bilingual-form-container {
    transform: none !important;
    transform-origin: top left !important;
    width: 100% !important;
    overflow: visible !important;
  }

  body.printing-mode #bilingual-form-container *,
  body.printing-mode .bilingual-form-container * {
    overflow: visible !important;
  }

  body.printing-mode #root,
  body.printing-mode #root > div,
  body.printing-mode #root > div > div {
    overflow: visible !important;
  }

  /* Header adjustments */
  #print-header-section {
    margin: 0 !important;
    border-width: 1px !important;
    padding: 4px 6px !important;
  }

  #print-header-content {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 8px 12px !important;
    gap: 12px !important;
  }

  #print-header-left {
    gap: 6px !important;
    align-items: center !important;
  }

  #print-logo-container {
    width: 48px !important;
    height: 48px !important;
    border-width: 1px !important;
    margin-right: 8px !important;
  }

  #print-company-info * {
    font-size: 11px !important;
    line-height: 1.2 !important;
  }

  #print-header-center * {
    font-size: 13px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
  }

  #print-header-right {
    display: none !important;
  }

  /* Delivery / Receiving layout */
  #print-delivery-content,
  #print-receiving-content {
    flex-direction: row !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  #print-delivery-media,
  #print-receiving-media {
    order: 1 !important;
    flex: 0 0 38% !important;
    max-width: 38% !important;
  }

  #print-delivery-details,
  #print-receiving-details {
    order: 2 !important;
    flex: 1 1 62% !important;
  }

  /* Grid for date/time and detail fields in delivery/receiving sections */
  #print-delivery-details > div:not(.conditionsContainer):not(.notesContainer),
  #print-receiving-details > div:not(.conditionsContainer):not(.notesContainer) {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 6px !important;
    margin-bottom: 6px !important;
  }

  /* Make individual input groups fit grid cells */
  #print-delivery-details .inputGroup,
  #print-receiving-details .inputGroup,
  #print-delivery-details > div > div,
  #print-receiving-details > div > div {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
  }

  /* Ensure dateTimeRow elements display as grid */
  .dateTimeRow,
  [style*="flexDirection: row"] {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 6px !important;
  }

  #print-delivery-photos,
  #print-receiving-photos {
    display: none !important;
  }

  #print-delivery-notes,
  #print-receiving-notes {
    margin-top: 4px !important;
  }

  /* Conditions as grid */
  .conditionsContainer {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 4px !important;
    margin-top: 6px !important;
  }

  .conditionRow {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 2px 4px !important;
    border: 1px solid #ddd !important;
    border-radius: 2px !important;
  }

  .conditionRow > div:first-child {
    flex: 1 !important;
    font-size: 9px !important;
  }

  .conditionRow > div:last-child {
    flex: 0 0 auto !important;
  }

  /* Input and label styling for landscape */
  .inputGroup,
  [class*="inputGroup"],
  [class*="input-group"] {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
    margin-bottom: 4px !important;
  }

  .labelText,
  [class*="labelText"],
  [class*="label"] {
    font-size: 9px !important;
    font-weight: 600 !important;
    margin-bottom: 2px !important;
  }

  input[type="text"],
  input[type="date"],
  input[type="time"],
  input[type="number"],
  textarea,
  .input,
  [class*="input"] {
    font-size: 10px !important;
    padding: 4px 6px !important;
    border: 1px solid #999 !important;
    border-radius: 3px !important;
  }

  /* Pledge section */
  #print-pledge-section {
    margin: 4px 0 !important;
  }

  #print-pledge-section * {
    font-size: 9px !important;
    line-height: 1.25 !important;
  }

  /* Signatures */
  #print-signature-section {
    margin-top: 6px !important;
    page-break-inside: avoid !important;
  }

  #print-signature-row {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 8px !important;
  }

  #print-signature-row > div {
    display: flex !important;
    flex-direction: column !important;
  }

  #print-signature-section * {
    font-size: 9px !important;
    line-height: 1.25 !important;
  }

  /* Card density */
  #print-basic-info-card,
  #print-partner-card,
  #print-delivery-card,
  #print-receiving-card,
  #print-pledge-card,
  #print-company-signature-card,
  #print-driver-signature-card,
  #print-secondary-signature-card {
    margin: 4px 0 !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  #print-basic-info-card > *,
  #print-partner-card > *,
  #print-delivery-card > *,
  #print-receiving-card > *,
  #print-pledge-card > *,
  #print-company-signature-card > *,
  #print-driver-signature-card > *,
  #print-secondary-signature-card > * {
    padding: 8px !important;
  }

  #print-basic-info-card * {
    font-size: 10px !important;
    line-height: 1.3 !important;
  }

  /* Grid layouts for form fields */
  #print-basic-info-card > div,
  #print-partner-card > div {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 8px !important;
    padding: 8px !important;
  }

  #print-basic-info-card > div > div,
  #print-partner-card > div > div {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
  }

  #print-company-signature-card *,
  #print-driver-signature-card *,
  #print-secondary-signature-card * {
    font-size: 9px !important;
  }

  /* Hide interactive controls */
  #print-action-buttons,
  #print-action-buttons * {
    display: none !important;
  }

  /* Make body occupy full page */
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Root container adjustments */
  .bilingual-form-container {
    background: white !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    font-size: 8px !important;
    line-height: 1.15 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Header section - compact for print */
  .form-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border: 2px solid #333 !important;
    padding: 6px 10px !important;
    margin-bottom: 6px !important;
    page-break-inside: avoid !important;
  }

  .company-logo {
    width: 40px !important;
    height: 40px !important;
  }

  .company-name-ar {
    font-size: 14px !important;
    font-weight: bold !important;
    text-align: right !important;
  }

  .company-name-en {
    font-size: 10px !important;
    text-align: right !important;
  }

  /* Basic information section */
  .basic-info-grid {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin-bottom: 10px !important;
    page-break-inside: avoid !important;
  }

  .input-group {
    margin-bottom: 4px !important;
  }

  .input-group label,
  .label-text {
    font-size: 9px !important;
    font-weight: bold !important;
    margin-bottom: 2px !important;
    display: block !important;
  }

  .input-group input,
  .form-input {
    border: 1px solid #666 !important;
    padding: 3px 6px !important;
    font-size: 10px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Form sections */
  .form-section {
    border: 1px solid #333 !important;
    margin-bottom: 6px !important;
    page-break-inside: avoid !important;
    background: white !important;
  }

  .section-title {
    background: #f0f0f0 !important;
    text-align: center !important;
    font-weight: bold !important;
    padding: 4px !important;
    font-size: 11px !important;
    border-bottom: 1px solid #333 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Two-column layout for delivery/receiving sections */
  .section-content {
    display: flex !important;
    padding: 6px !important;
  }

  .left-column {
    flex: 1 !important;
    padding-right: 6px !important;
  }

  .right-column {
    flex: 1 !important;
    padding-left: 6px !important;
  }

  /* Vehicle diagram */
  .vehicle-diagram-container {
    border: 1px solid #666 !important;
    padding: 4px !important;
    margin-bottom: 6px !important;
    text-align: center !important;
  }

  .vehicle-diagram {
    width: 110px !important;
    height: 72px !important;
    border: 2px solid #333 !important;
    margin: 0 auto !important;
    position: relative !important;
  }

  .vehicle-top,
  .vehicle-bottom {
    height: 15px !important;
    text-align: center !important;
    font-size: 8px !important;
    line-height: 15px !important;
  }

  .vehicle-middle {
    height: 44px !important;
    display: flex !important;
    border-top: 1px solid #666 !important;
    border-bottom: 1px solid #666 !important;
  }

  .vehicle-left,
  .vehicle-right {
    width: 22px !important;
    border-right: 1px solid #666 !important;
    font-size: 7px !important;
    text-align: center !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .vehicle-center {
    flex: 1 !important;
    background: #f9f9f9 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Date and time inputs */
  .date-time-row {
    display: flex !important;
    gap: 6px !important;
    margin-bottom: 6px !important;
  }

  .date-time-row .input-group {
    flex: 1 !important;
  }

  /* Condition assessment grid */
  .conditions-container {
    margin-top: 8px !important;
  }

  .condition-row {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 3px !important;
    padding: 2px 0 !important;
    border-bottom: 1px dotted #ccc !important;
  }

  .condition-label {
    flex: 1 !important;
    font-size: 8px !important;
    text-align: right !important;
    padding-right: 4px !important;
  }

  .condition-options {
    display: flex !important;
    gap: 4px !important;
  }

  .condition-option {
    width: 12px !important;
    height: 12px !important;
    border: 1px solid #333 !important;
    font-size: 7px !important;
    text-align: center !important;
    line-height: 10px !important;
  }

  .selected-condition {
    background: #333 !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Notes section */
  .notes-container {
    margin-top: 6px !important;
  }

  .notes-label {
    font-size: 9px !important;
    font-weight: bold !important;
    text-align: center !important;
    margin-bottom: 3px !important;
  }

  .notes-input {
    border: 1px solid #666 !important;
    min-height: 30px !important;
    padding: 3px !important;
    font-size: 9px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Receiving details grid */
  .receiving-details-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 4px !important;
    margin-bottom: 6px !important;
  }

  /* Driver's pledge section */
  .pledge-section {
    border: 1px solid #333 !important;
    padding: 6px !important;
    margin-bottom: 6px !important;
    background: #f9f9f9 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    page-break-inside: avoid !important;
  }

  .pledge-title {
    font-size: 12px !important;
    font-weight: bold !important;
    text-align: center !important;
    margin-bottom: 8px !important;
  }

  .pledge-text {
    font-size: 9px !important;
    text-align: right !important;
    margin-bottom: 4px !important;
    line-height: 1.3 !important;
  }

  .pledge-text-en {
    font-size: 8px !important;
    text-align: left !important;
    color: #666 !important;
    margin-bottom: 4px !important;
  }

  /* Signature section */
  .signature-section {
    page-break-inside: avoid !important;
    margin-top: 10px !important;
  }

  .signature-row {
    display: flex !important;
    gap: 8px !important;
  }

  .signature-card {
    flex: 1 !important;
    border: 1px solid #333 !important;
    padding: 6px !important;
  }

  .signature-header {
    background: #e6f3ff !important;
    padding: 4px !important;
    text-align: center !important;
    margin-bottom: 6px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .signature-title {
    font-size: 9px !important;
    font-weight: bold !important;
  }

  .signature-content {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }

  .signature-box,
  .signature-display {
    height: 32px !important;
    border: 1px solid #666 !important;
    background: white !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .signature-placeholder {
    font-size: 8px !important;
    color: #666 !important;
  }

  /* Hide action buttons in print */
  .button-section,
  .action-buttons,
  .no-print {
    display: none !important;
  }

  /* Force page breaks */
  .page-break-before {
    page-break-before: always !important;
  }

  .page-break-after {
    page-break-after: always !important;
  }

  .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  /* Ensure proper text rendering */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Fix for text inputs to show content */
  input[type="text"],
  input[type="date"],
  input[type="time"],
  textarea {
    border: 1px solid #666 !important;
    background: white !important;
    color: black !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
  }

  /* Compact spacing for print */
  .form-container {
    font-family: Arial, sans-serif !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Header logo positioning */
  .header-content {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .header-left {
    flex: 1 !important;
    text-align: right !important;
  }

  .header-right {
    flex: 1 !important;
    text-align: left !important;
  }

  .logo-container {
    width: 50px !important;
    height: 50px !important;
    border: 2px solid #333 !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 10px !important;
  }

  /* Ensure proper Arabic text direction */
  .arabic-text,
  [dir="rtl"] {
    direction: rtl !important;
    text-align: right !important;
  }

  .english-text,
  [dir="ltr"] {
    direction: ltr !important;
    text-align: left !important;
  }

  /* Responsive print adjustments */
  @media print and (max-width: 8.5in) {
    .section-content {
      flex-direction: column !important;
    }

    .left-column,
    .right-column {
      flex: none !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .signature-row {
      flex-direction: column !important;
    }

    .basic-info-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }

  /* ===================================================================
     HISTORY DISPLAY PRINT STYLES (ReceivingHistoryDisplay & DeliveryHistoryDisplay)
     =================================================================== */

  /* When printing forms, hide everything except the form container */
  body.printing-receiving-form *,
  body.printing-delivery-form * {
    visibility: hidden !important;
  }

  /* Show only the form container and its children */
  body.printing-receiving-form #receiving-history-container,
  body.printing-receiving-form #receiving-history-container *,
  body.printing-delivery-form #delivery-history-container,
  body.printing-delivery-form #delivery-history-container * {
    visibility: visible !important;
  }

  /* Position the form to fill the page */
  body.printing-receiving-form #receiving-history-container,
  body.printing-delivery-form #delivery-history-container {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    overflow: visible !important;
  }

  /* Make scrollview content visible */
  body.printing-receiving-form #receiving-history-container>div,
  body.printing-delivery-form #delivery-history-container>div {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }

  /* Hide print button */
  body.printing-receiving-form button,
  body.printing-delivery-form button {
    display: none !important;
    visibility: hidden !important;
  }

  /* Standard @media print rules as fallback */
  @media print {

    /* Hide buttons */
    button,
    [role="button"],
    [type="button"] {
      display: none !important;
    }

    /* Hide navigation elements */
    [role="navigation"],
    [role="banner"],
    nav,
    header:not(#receiving-history-container header):not(#delivery-history-container header) {
      display: none !important;
    }

    /* Hide tabs */
    [role="tablist"],
    [role="tab"]:not([role="tabpanel"]) {
      display: none !important;
    }

    /* Ensure form containers are visible and take full width */
    #receiving-history-container,
    #delivery-history-container {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      overflow: visible !important;
      page-break-inside: avoid;
    }

    /* Make sure scrollview shows all content */
    #receiving-history-container>div,
    #delivery-history-container>div {
      overflow: visible !important;
      height: auto !important;
      max-height: none !important;
    }

    /* Ensure content visibility */
    #receiving-history-container *,
    #delivery-history-container * {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
}

/* Print utility classes */
.print-only {
  display: none;
}

@media print {
  .print-only {
    display: block !important;
  }

  .screen-only {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE,6CAA6C;;AAE7C;;EAEE,gCAAgC;EAChC;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,8CAA8C;EAC9C;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;0EAEwE;EACxE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAyCE,wBAAwB;IACxB,6BAA6B;IAC7B,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA,kEAAkE;EAClE;IACE,wBAAwB;EAC1B;;EAEA,2DAA2D;EAC3D;;;;IAIE,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;;;;IAIE,0BAA0B;IAC1B,qCAAqC;IACrC,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;;IAGE,4BAA4B;EAC9B;;EAEA,uBAAuB;EACvB;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,gCAAgC;EAChC;;IAEE,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;;IAEE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA,wEAAwE;EACxE;;IAEE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA,gDAAgD;EAChD;;;;IAIE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA,gDAAgD;EAChD;;IAEE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;EACrB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,0CAA0C;EAC1C;;;IAGE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;;;IAGE,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;;;;;;IAOE,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA,mBAAmB;EACnB;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA,eAAe;EACf;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA,iBAAiB;EACjB;;;;;;;;IAQE,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;;;;;;;;IAQE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;;IAEE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA,8BAA8B;EAC9B;;IAEE,wBAAwB;EAC1B;;EAEA,+BAA+B;EAC/B;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,+BAA+B;EAC/B;IACE,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,mBAAmB;IACnB,8BAA8B;IAC9B,mCAAmC;EACrC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;;IAEE,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,kBAAkB;EAClB;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IACnC,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,uBAAuB;IACvB,0BAA0B;IAC1B,wCAAwC;IACxC,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,sDAAsD;EACtD;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA,oBAAoB;EACpB;IACE,iCAAiC;IACjC,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,qCAAqC;IACrC,wCAAwC;EAC1C;;EAEA;;IAEE,sBAAsB;IACtB,uCAAuC;IACvC,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,yBAAyB;EACzB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,8BAA8B;EAC9B;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;IACzB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,2BAA2B;EAC3B;IACE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA,4BAA4B;EAC5B;IACE,iCAAiC;IACjC,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA,sBAAsB;EACtB;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,iCAAiC;EACjC;;;IAGE,wBAAwB;EAC1B;;EAEA,sBAAsB;EACtB;IACE,oCAAoC;EACtC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA,iCAAiC;EACjC;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA,wCAAwC;EACxC;;;;IAIE,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA,8BAA8B;EAC9B;IACE,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,yBAAyB;EAC3B;;EAEA,wCAAwC;EACxC;;IAEE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE;MACE,iCAAiC;IACnC;;IAEA;;MAEE,qBAAqB;MACrB,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,gDAAgD;IAClD;EACF;;EAEA;;0EAEwE;;EAExE,mEAAmE;EACnE;;IAEE,6BAA6B;EAC/B;;EAEA,kDAAkD;EAClD;;;;IAIE,8BAA8B;EAChC;;EAEA,uCAAuC;EACvC;;IAEE,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA,oCAAoC;EACpC;;IAEE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;;IAEE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA,4CAA4C;EAC5C;;IAEE,iBAAiB;IACjB;;;MAGE,wBAAwB;IAC1B;;IAEA,6BAA6B;IAC7B;;;;MAIE,wBAAwB;IAC1B;;IAEA,cAAc;IACd;;MAEE,wBAAwB;IAC1B;;IAEA,2DAA2D;IAC3D;;MAEE,yBAAyB;MACzB,sBAAsB;MACtB,0BAA0B;MAC1B,4BAA4B;MAC5B,wBAAwB;IAC1B;;IAEA,2CAA2C;IAC3C;;MAEE,4BAA4B;MAC5B,uBAAuB;MACvB,2BAA2B;IAC7B;;IAEA,8BAA8B;IAC9B;;MAEE,8BAA8B;MAC9B,qBAAqB;IACvB;EACF;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Print Styles for Bilingual Assignment Forms and History Displays */\n/* A4 Paper: 210mm x 297mm (8.27\" x 11.69\") */\n\n@media print {\n\n  /* Reset and prepare for print */\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Reset margins and ensure proper A4 sizing */\n  @page {\n    size: A4 landscape;\n    margin: 8mm 10mm 8mm 10mm;\n  }\n\n  /* ===================================================================\n     UNIVERSAL HIDING RULES - Hide navigation and chrome\n     =================================================================== */\n  .no-print,\n  .print-hidden,\n  [data-print=\"hidden\"],\n  nav,\n  .sidebar,\n  .navigation,\n  .menu,\n  .drawer,\n  .header-buttons,\n  .back-button,\n  .floating-button,\n  .fab,\n  .modal-backdrop,\n  .app-header,\n  .app-navigation,\n  [role=\"navigation\"],\n  [data-testid*=\"navigation\"],\n  [data-testid*=\"sidebar\"],\n  [data-testid*=\"menu\"],\n  .screen-header,\n  .top-bar,\n  .status-bar,\n  .tab-bar,\n  .bottom-navigation,\n  .main-navigation,\n  .navigation-drawer,\n  .app-drawer,\n  .react-navigation-stack,\n  .rn-screen,\n  [class*=\"navigation\"],\n  [class*=\"sidebar\"],\n  [class*=\"header\"],\n  [class*=\"menu\"],\n  [class*=\"drawer\"],\n  [id*=\"navigation\"],\n  [id*=\"sidebar\"],\n  [id*=\"header\"],\n  [id*=\"menu\"],\n  /* React Native Web specific */\n  [style*=\"width: 280px\"],\n  [style*=\"border-right\"] {\n    display: none !important;\n    visibility: hidden !important;\n    position: absolute !important;\n    left: -9999px !important;\n  }\n\n  /* Hide all body children except the app root or print container */\n  body.printing-mode>div:not(#root):not(.bilingual-form-container):not([class*=\"form\"]) {\n    display: none !important;\n  }\n\n  /* Ensure the form container uses normal flow for scaling */\n  .bilingual-form-container,\n  [class*=\"assignment-form\"],\n  [class*=\"bilingual-form\"],\n  #bilingual-form-container {\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    right: auto !important;\n    bottom: auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: auto !important;\n    z-index: 9999 !important;\n    overflow: visible !important;\n  }\n\n  body.printing-mode .bilingual-form-container,\n  body.printing-mode [class*=\"assignment-form\"],\n  body.printing-mode [class*=\"bilingual-form\"],\n  body.printing-mode #bilingual-form-container {\n    transform: none !important;\n    transform-origin: top left !important;\n    width: 100% !important;\n    overflow: visible !important;\n  }\n\n  body.printing-mode #bilingual-form-container *,\n  body.printing-mode .bilingual-form-container * {\n    overflow: visible !important;\n  }\n\n  body.printing-mode #root,\n  body.printing-mode #root > div,\n  body.printing-mode #root > div > div {\n    overflow: visible !important;\n  }\n\n  /* Header adjustments */\n  #print-header-section {\n    margin: 0 !important;\n    border-width: 1px !important;\n    padding: 4px 6px !important;\n  }\n\n  #print-header-content {\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 8px 12px !important;\n    gap: 12px !important;\n  }\n\n  #print-header-left {\n    gap: 6px !important;\n    align-items: center !important;\n  }\n\n  #print-logo-container {\n    width: 48px !important;\n    height: 48px !important;\n    border-width: 1px !important;\n    margin-right: 8px !important;\n  }\n\n  #print-company-info * {\n    font-size: 11px !important;\n    line-height: 1.2 !important;\n  }\n\n  #print-header-center * {\n    font-size: 13px !important;\n    line-height: 1.2 !important;\n    font-weight: 600 !important;\n  }\n\n  #print-header-right {\n    display: none !important;\n  }\n\n  /* Delivery / Receiving layout */\n  #print-delivery-content,\n  #print-receiving-content {\n    flex-direction: row !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n  }\n\n  #print-delivery-media,\n  #print-receiving-media {\n    order: 1 !important;\n    flex: 0 0 38% !important;\n    max-width: 38% !important;\n  }\n\n  #print-delivery-details,\n  #print-receiving-details {\n    order: 2 !important;\n    flex: 1 1 62% !important;\n  }\n\n  /* Grid for date/time and detail fields in delivery/receiving sections */\n  #print-delivery-details > div:not(.conditionsContainer):not(.notesContainer),\n  #print-receiving-details > div:not(.conditionsContainer):not(.notesContainer) {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 6px !important;\n    margin-bottom: 6px !important;\n  }\n\n  /* Make individual input groups fit grid cells */\n  #print-delivery-details .inputGroup,\n  #print-receiving-details .inputGroup,\n  #print-delivery-details > div > div,\n  #print-receiving-details > div > div {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 2px !important;\n  }\n\n  /* Ensure dateTimeRow elements display as grid */\n  .dateTimeRow,\n  [style*=\"flexDirection: row\"] {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 6px !important;\n  }\n\n  #print-delivery-photos,\n  #print-receiving-photos {\n    display: none !important;\n  }\n\n  #print-delivery-notes,\n  #print-receiving-notes {\n    margin-top: 4px !important;\n  }\n\n  /* Conditions as grid */\n  .conditionsContainer {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 4px !important;\n    margin-top: 6px !important;\n  }\n\n  .conditionRow {\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 2px 4px !important;\n    border: 1px solid #ddd !important;\n    border-radius: 2px !important;\n  }\n\n  .conditionRow > div:first-child {\n    flex: 1 !important;\n    font-size: 9px !important;\n  }\n\n  .conditionRow > div:last-child {\n    flex: 0 0 auto !important;\n  }\n\n  /* Input and label styling for landscape */\n  .inputGroup,\n  [class*=\"inputGroup\"],\n  [class*=\"input-group\"] {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 2px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .labelText,\n  [class*=\"labelText\"],\n  [class*=\"label\"] {\n    font-size: 9px !important;\n    font-weight: 600 !important;\n    margin-bottom: 2px !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"date\"],\n  input[type=\"time\"],\n  input[type=\"number\"],\n  textarea,\n  .input,\n  [class*=\"input\"] {\n    font-size: 10px !important;\n    padding: 4px 6px !important;\n    border: 1px solid #999 !important;\n    border-radius: 3px !important;\n  }\n\n  /* Pledge section */\n  #print-pledge-section {\n    margin: 4px 0 !important;\n  }\n\n  #print-pledge-section * {\n    font-size: 9px !important;\n    line-height: 1.25 !important;\n  }\n\n  /* Signatures */\n  #print-signature-section {\n    margin-top: 6px !important;\n    page-break-inside: avoid !important;\n  }\n\n  #print-signature-row {\n    display: grid !important;\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 8px !important;\n  }\n\n  #print-signature-row > div {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  #print-signature-section * {\n    font-size: 9px !important;\n    line-height: 1.25 !important;\n  }\n\n  /* Card density */\n  #print-basic-info-card,\n  #print-partner-card,\n  #print-delivery-card,\n  #print-receiving-card,\n  #print-pledge-card,\n  #print-company-signature-card,\n  #print-driver-signature-card,\n  #print-secondary-signature-card {\n    margin: 4px 0 !important;\n    border-radius: 4px !important;\n    border-width: 1px !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n  }\n\n  #print-basic-info-card > *,\n  #print-partner-card > *,\n  #print-delivery-card > *,\n  #print-receiving-card > *,\n  #print-pledge-card > *,\n  #print-company-signature-card > *,\n  #print-driver-signature-card > *,\n  #print-secondary-signature-card > * {\n    padding: 8px !important;\n  }\n\n  #print-basic-info-card * {\n    font-size: 10px !important;\n    line-height: 1.3 !important;\n  }\n\n  /* Grid layouts for form fields */\n  #print-basic-info-card > div,\n  #print-partner-card > div {\n    display: grid !important;\n    grid-template-columns: repeat(4, 1fr) !important;\n    gap: 8px !important;\n    padding: 8px !important;\n  }\n\n  #print-basic-info-card > div > div,\n  #print-partner-card > div > div {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 2px !important;\n  }\n\n  #print-company-signature-card *,\n  #print-driver-signature-card *,\n  #print-secondary-signature-card * {\n    font-size: 9px !important;\n  }\n\n  /* Hide interactive controls */\n  #print-action-buttons,\n  #print-action-buttons * {\n    display: none !important;\n  }\n\n  /* Make body occupy full page */\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Root container adjustments */\n  .bilingual-form-container {\n    background: white !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n    font-size: 8px !important;\n    line-height: 1.15 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  /* Header section - compact for print */\n  .form-header {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    border: 2px solid #333 !important;\n    padding: 6px 10px !important;\n    margin-bottom: 6px !important;\n    page-break-inside: avoid !important;\n  }\n\n  .company-logo {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .company-name-ar {\n    font-size: 14px !important;\n    font-weight: bold !important;\n    text-align: right !important;\n  }\n\n  .company-name-en {\n    font-size: 10px !important;\n    text-align: right !important;\n  }\n\n  /* Basic information section */\n  .basic-info-grid {\n    display: grid !important;\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin-bottom: 10px !important;\n    page-break-inside: avoid !important;\n  }\n\n  .input-group {\n    margin-bottom: 4px !important;\n  }\n\n  .input-group label,\n  .label-text {\n    font-size: 9px !important;\n    font-weight: bold !important;\n    margin-bottom: 2px !important;\n    display: block !important;\n  }\n\n  .input-group input,\n  .form-input {\n    border: 1px solid #666 !important;\n    padding: 3px 6px !important;\n    font-size: 10px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Form sections */\n  .form-section {\n    border: 1px solid #333 !important;\n    margin-bottom: 6px !important;\n    page-break-inside: avoid !important;\n    background: white !important;\n  }\n\n  .section-title {\n    background: #f0f0f0 !important;\n    text-align: center !important;\n    font-weight: bold !important;\n    padding: 4px !important;\n    font-size: 11px !important;\n    border-bottom: 1px solid #333 !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Two-column layout for delivery/receiving sections */\n  .section-content {\n    display: flex !important;\n    padding: 6px !important;\n  }\n\n  .left-column {\n    flex: 1 !important;\n    padding-right: 6px !important;\n  }\n\n  .right-column {\n    flex: 1 !important;\n    padding-left: 6px !important;\n  }\n\n  /* Vehicle diagram */\n  .vehicle-diagram-container {\n    border: 1px solid #666 !important;\n    padding: 4px !important;\n    margin-bottom: 6px !important;\n    text-align: center !important;\n  }\n\n  .vehicle-diagram {\n    width: 110px !important;\n    height: 72px !important;\n    border: 2px solid #333 !important;\n    margin: 0 auto !important;\n    position: relative !important;\n  }\n\n  .vehicle-top,\n  .vehicle-bottom {\n    height: 15px !important;\n    text-align: center !important;\n    font-size: 8px !important;\n    line-height: 15px !important;\n  }\n\n  .vehicle-middle {\n    height: 44px !important;\n    display: flex !important;\n    border-top: 1px solid #666 !important;\n    border-bottom: 1px solid #666 !important;\n  }\n\n  .vehicle-left,\n  .vehicle-right {\n    width: 22px !important;\n    border-right: 1px solid #666 !important;\n    font-size: 7px !important;\n    text-align: center !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .vehicle-center {\n    flex: 1 !important;\n    background: #f9f9f9 !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Date and time inputs */\n  .date-time-row {\n    display: flex !important;\n    gap: 6px !important;\n    margin-bottom: 6px !important;\n  }\n\n  .date-time-row .input-group {\n    flex: 1 !important;\n  }\n\n  /* Condition assessment grid */\n  .conditions-container {\n    margin-top: 8px !important;\n  }\n\n  .condition-row {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    margin-bottom: 3px !important;\n    padding: 2px 0 !important;\n    border-bottom: 1px dotted #ccc !important;\n  }\n\n  .condition-label {\n    flex: 1 !important;\n    font-size: 8px !important;\n    text-align: right !important;\n    padding-right: 4px !important;\n  }\n\n  .condition-options {\n    display: flex !important;\n    gap: 4px !important;\n  }\n\n  .condition-option {\n    width: 12px !important;\n    height: 12px !important;\n    border: 1px solid #333 !important;\n    font-size: 7px !important;\n    text-align: center !important;\n    line-height: 10px !important;\n  }\n\n  .selected-condition {\n    background: #333 !important;\n    color: white !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Notes section */\n  .notes-container {\n    margin-top: 6px !important;\n  }\n\n  .notes-label {\n    font-size: 9px !important;\n    font-weight: bold !important;\n    text-align: center !important;\n    margin-bottom: 3px !important;\n  }\n\n  .notes-input {\n    border: 1px solid #666 !important;\n    min-height: 30px !important;\n    padding: 3px !important;\n    font-size: 9px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Receiving details grid */\n  .receiving-details-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 4px !important;\n    margin-bottom: 6px !important;\n  }\n\n  /* Driver's pledge section */\n  .pledge-section {\n    border: 1px solid #333 !important;\n    padding: 6px !important;\n    margin-bottom: 6px !important;\n    background: #f9f9f9 !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    page-break-inside: avoid !important;\n  }\n\n  .pledge-title {\n    font-size: 12px !important;\n    font-weight: bold !important;\n    text-align: center !important;\n    margin-bottom: 8px !important;\n  }\n\n  .pledge-text {\n    font-size: 9px !important;\n    text-align: right !important;\n    margin-bottom: 4px !important;\n    line-height: 1.3 !important;\n  }\n\n  .pledge-text-en {\n    font-size: 8px !important;\n    text-align: left !important;\n    color: #666 !important;\n    margin-bottom: 4px !important;\n  }\n\n  /* Signature section */\n  .signature-section {\n    page-break-inside: avoid !important;\n    margin-top: 10px !important;\n  }\n\n  .signature-row {\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  .signature-card {\n    flex: 1 !important;\n    border: 1px solid #333 !important;\n    padding: 6px !important;\n  }\n\n  .signature-header {\n    background: #e6f3ff !important;\n    padding: 4px !important;\n    text-align: center !important;\n    margin-bottom: 6px !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .signature-title {\n    font-size: 9px !important;\n    font-weight: bold !important;\n  }\n\n  .signature-content {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 4px !important;\n  }\n\n  .signature-box,\n  .signature-display {\n    height: 32px !important;\n    border: 1px solid #666 !important;\n    background: white !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .signature-placeholder {\n    font-size: 8px !important;\n    color: #666 !important;\n  }\n\n  /* Hide action buttons in print */\n  .button-section,\n  .action-buttons,\n  .no-print {\n    display: none !important;\n  }\n\n  /* Force page breaks */\n  .page-break-before {\n    page-break-before: always !important;\n  }\n\n  .page-break-after {\n    page-break-after: always !important;\n  }\n\n  .page-break-inside-avoid {\n    page-break-inside: avoid !important;\n  }\n\n  /* Ensure proper text rendering */\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  /* Fix for text inputs to show content */\n  input[type=\"text\"],\n  input[type=\"date\"],\n  input[type=\"time\"],\n  textarea {\n    border: 1px solid #666 !important;\n    background: white !important;\n    color: black !important;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n  }\n\n  /* Compact spacing for print */\n  .form-container {\n    font-family: Arial, sans-serif !important;\n    max-width: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  /* Header logo positioning */\n  .header-content {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n  }\n\n  .header-left {\n    flex: 1 !important;\n    text-align: right !important;\n  }\n\n  .header-right {\n    flex: 1 !important;\n    text-align: left !important;\n  }\n\n  .logo-container {\n    width: 50px !important;\n    height: 50px !important;\n    border: 2px solid #333 !important;\n    border-radius: 50% !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin: 0 10px !important;\n  }\n\n  /* Ensure proper Arabic text direction */\n  .arabic-text,\n  [dir=\"rtl\"] {\n    direction: rtl !important;\n    text-align: right !important;\n  }\n\n  .english-text,\n  [dir=\"ltr\"] {\n    direction: ltr !important;\n    text-align: left !important;\n  }\n\n  /* Responsive print adjustments */\n  @media print and (max-width: 8.5in) {\n    .section-content {\n      flex-direction: column !important;\n    }\n\n    .left-column,\n    .right-column {\n      flex: none !important;\n      width: 100% !important;\n      padding: 0 !important;\n    }\n\n    .signature-row {\n      flex-direction: column !important;\n    }\n\n    .basic-info-grid {\n      grid-template-columns: repeat(2, 1fr) !important;\n    }\n  }\n\n  /* ===================================================================\n     HISTORY DISPLAY PRINT STYLES (ReceivingHistoryDisplay & DeliveryHistoryDisplay)\n     =================================================================== */\n\n  /* When printing forms, hide everything except the form container */\n  body.printing-receiving-form *,\n  body.printing-delivery-form * {\n    visibility: hidden !important;\n  }\n\n  /* Show only the form container and its children */\n  body.printing-receiving-form #receiving-history-container,\n  body.printing-receiving-form #receiving-history-container *,\n  body.printing-delivery-form #delivery-history-container,\n  body.printing-delivery-form #delivery-history-container * {\n    visibility: visible !important;\n  }\n\n  /* Position the form to fill the page */\n  body.printing-receiving-form #receiving-history-container,\n  body.printing-delivery-form #delivery-history-container {\n    position: absolute !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 100% !important;\n    overflow: visible !important;\n  }\n\n  /* Make scrollview content visible */\n  body.printing-receiving-form #receiving-history-container>div,\n  body.printing-delivery-form #delivery-history-container>div {\n    overflow: visible !important;\n    height: auto !important;\n    max-height: none !important;\n  }\n\n  /* Hide print button */\n  body.printing-receiving-form button,\n  body.printing-delivery-form button {\n    display: none !important;\n    visibility: hidden !important;\n  }\n\n  /* Standard @media print rules as fallback */\n  @media print {\n\n    /* Hide buttons */\n    button,\n    [role=\"button\"],\n    [type=\"button\"] {\n      display: none !important;\n    }\n\n    /* Hide navigation elements */\n    [role=\"navigation\"],\n    [role=\"banner\"],\n    nav,\n    header:not(#receiving-history-container header):not(#delivery-history-container header) {\n      display: none !important;\n    }\n\n    /* Hide tabs */\n    [role=\"tablist\"],\n    [role=\"tab\"]:not([role=\"tabpanel\"]) {\n      display: none !important;\n    }\n\n    /* Ensure form containers are visible and take full width */\n    #receiving-history-container,\n    #delivery-history-container {\n      display: block !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      overflow: visible !important;\n      page-break-inside: avoid;\n    }\n\n    /* Make sure scrollview shows all content */\n    #receiving-history-container>div,\n    #delivery-history-container>div {\n      overflow: visible !important;\n      height: auto !important;\n      max-height: none !important;\n    }\n\n    /* Ensure content visibility */\n    #receiving-history-container *,\n    #delivery-history-container * {\n      visibility: visible !important;\n      opacity: 1 !important;\n    }\n  }\n}\n\n/* Print utility classes */\n.print-only {\n  display: none;\n}\n\n@media print {\n  .print-only {\n    display: block !important;\n  }\n\n  .screen-only {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
